module.exports = __webpack_public_path__ + "static/media/feeling-bad.f4c768c1.svg";